import { Pipe, PipeTransform } from '@angular/core';

@Pipe( { name: 'emptyAny' })
export class EmptyAnyPipe implements PipeTransform {
  transform( value: any ) {
    if (value === null || value === '' || value === ' ' || typeof value === 'undefined') {
      return 'Any';
    }
    return value;
  }
}
